import React, { Component } from 'react'
import { recruiterProfileDetails } from '../../action/profile';
import Shimmer from '../../old_Components/Common/Shimmer';
import AsideRightMenu from '../../old_Components/Dashboard/AsideRightMenu';
import EditProfile from '../../old_Components/EditProfile/EditProfile'
import constant from '../../constant'
export default class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: undefined
        }
    }

    componentDidMount() {
        recruiterProfileDetails().then((res) => {
            if (res.status) {
                this.setState({ details: res.result })
            }
        })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.details === undefined && <section className='pricing-area padding-top-100px padding-bottom-80px'>
                    <div className="container">
                        <div className='row'>
                            <div className='col-md-3 mt-3'>
                                <AsideRightMenu />
                            </div>
                            <div className='col-md-9'>
                                <Shimmer />
                            </div>
                        </div>
                    </div>

                </section>
                }
                {this.state.details && <EditProfile
                    details={this.state.details} />}
            </React.Fragment>
        )
    }
}
